import van from '../img/cars/van.png';
import mini from '../img/cars/mini.png';
import truck from '../img/cars/truck.jpg';
import truck2 from '../img/cars/truck2.png';
import economy from '../img/cars/economy.png';
import economy1 from '../img/cars/economy1.png';
import economy2 from '../img/cars/economy2.png';
import standard from '../img/cars/standard.png';
import standard_suv from '../img/cars/standard_suv.png';
import standard_suv2 from '../img/cars/standard_suv2.png';
import full_suv from '../img/cars/full_suv.png';
import luxury from '../img/cars/luxury.png';
import luxury1 from '../img/cars/luxury2.png';
import luxury2 from '../img/cars/luxury3.png';
import intermediate from '../img/cars/intermediate.png';
import bus from '../img/cars/bus.png';
import big_bus from '../img/cars/big_bus.png';
import { trackClick } from '../ga';
import { useTranslation } from "react-i18next";


// src/Pages/Fleet.js
import {
  Box,
  Heading,
  Text,
  Container,
  Image,
  SimpleGrid,
  Stack,
  useColorModeValue, useBreakpointValue
} from "@chakra-ui/react";

const vehicles = [
  { key: "mini", image: mini },
  { key: "economy", image: economy },
    { key: "economy", image: economy1 },
      { key: "economy", image: economy2 },
  { key: "intermediate", image: intermediate },
  { key: "standard", image: standard },
  { key: "luxury", image: luxury },
    { key: "luxury", image: luxury1 },
      { key: "luxury", image: luxury2 },
  { key: "standard_suv", image: standard_suv },
    { key: "standard_suv", image: standard_suv2 },
  { key: "full_suv", image: full_suv },
  { key: "van", image: van },
  { key: "truck", image: truck },
  { key: "truck", image: truck2 },
    { key: "bus", image: bus },
      { key: "big_bus", image: big_bus },
];

export default function FleetPage() {
  const orgColor = "#ec562c";
  const bluColor = "#2f4280";
  const textColor = useColorModeValue("gray.700", "gray.100");
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  return (
    <Box py={10} bgGradient="linear(to-b, #ffffff, #2f4280)"   onClick={() => trackClick(`Clicked fleet page`)}>
      <Container maxW="7xl" pt={"50px"} py={10} textAlign={isArabic ? "right" : "left"}>
        {/* Page Title */}


        <Heading
          textAlign="center"
          mb={4}
          fontSize="4xl"
          color={bluColor}
          fontWeight="bold"
        >
          {i18n.language === "ar" ? "أسطول المركبات" : "Our Fleet"}
        </Heading>
        <Text
          textAlign="center"
          fontSize="lg"
          color={textColor}
          maxW="3xl"
          mx="auto"
          mb={10}
        >
          {t("fleet.description")}
        </Text>

        <SimpleGrid mt={5} columns={{ base: 1, sm: 2, md: 3 }} spacing={10} color={"gray.600"}>
          {vehicles.map((vehicle) => (
            <Box boxShadow="md" borderRadius="xl" overflow="hidden" bg="white" 
            onClick={() => trackClick(`Clicked ${vehicle.key}`)}>
              <Image src={vehicle.image} alt={vehicle.key} objectFit="cover" />
              {/* <Box p={4} >
                <Heading size="md" mb={1}>{t(`fleet.types.${vehicle.key}.title`)}</Heading>
                <Text fontSize="sm">{t(`fleet.types.${vehicle.key}.desc`)}</Text>
              </Box> */}
            </Box>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
}